// Launcher tile configuration.
// To enable a new app: set enabled: true and fill in devUrl / prodUrl.
// The portal opens each app via token-passing SSO:
//   {appUrl}/sso?token={JWT}&u={base64(userJson)}
// The target app must have an /sso route that stores the token and redirects.

// Where the LAUNCHED apps live (not where the portal runs).
// The portal launches DEPLOYED apps, so default to 'prod'.
// Set to 'dev' only if you also run each target app locally (localhost:3000 etc).
const TARGET = 'prod';

export const APPS = [
  {
    key: 'devops',
    name: 'DevOps Center',
    description: 'Pipelines, deployments & CF apps',
    icon: '🔧',
    color: '#1a56db',
    enabled: true,
    devUrl: 'http://localhost:3000',
    prodUrl: 'https://devops.cloudleaders.co.in',
    // Optional: only show tile to certain roles. Empty = all roles.
    roles: [],
  },
  {
    key: 'pm',
    name: 'PM Center',
    description: 'Projects, tasks, milestones & Gantt',
    icon: '📋',
    color: '#7c3aed',
    enabled: false, // flip to true once PM has an /sso route
    devUrl: 'http://localhost:3001',
    prodUrl: 'https://pm.cloudleaders.co.in',
    roles: [],
  },
  {
    key: 'support',
    name: 'Support Center',
    description: 'Tickets & customer support',
    icon: '🎧',
    color: '#ea580c',
    enabled: false, // flip to true once Support Center has an /sso route
    devUrl: 'http://localhost:3004',
    prodUrl: 'https://support.cloudleaders.co.in',
    roles: [],
  },
  {
    key: 'dsp',
    name: 'Digital Signature',
    description: 'Document signing (opens in new tab)',
    icon: '✍️',
    color: '#059669',
    enabled: true,
    external: true, // not a CLTS internal app — open in a new tab, no SSO handoff
    devUrl: 'https://sign.cloudleaders.co.in',
    prodUrl: 'https://sign.cloudleaders.co.in',
    roles: [],
  },
];

export function appUrl(app) {
  return TARGET === 'dev' ? app.devUrl : app.prodUrl;
}
